export enum KakaoentPolicyType {
  /**
   * 개인정보처리방침
   */
  Policy = 'policy',
  /**
   * 구 PersonalAd
   */
  TargetAd = 'targetAd',
}
